// extracted by mini-css-extract-plugin
export var askAiIcon = "_o9-9";
export var container = "_o9-0";
export var groupSeparator = "_o9-a";
export var highlight = "_o9-4";
export var resultIcon = "_o9-5";
export var resultItem = "_o9-7";
export var resultSubtitle = "_o9-3";
export var resultTitle = "_o9-2";
export var resultsList = "_o9-1";
export var searchGroup = "_o9-6";
export var selected = "_o9-8";